<template>
  <v-card>
    <v-card-text>
      <div class="pt-2 d-flex pb-2 px-2">
        <span class="center-filter">
          <universal-input
            v-model="centerId"
            :config="centerIdConfig"
          >
          </universal-input>
        </span>
        <span>
          <v-btn
            plain
            color="primary"
            class="ml-2"
            @click="refresh()"
          >
            <v-icon>
              mdi-refresh
            </v-icon>
          </v-btn>
        </span>
      </div>
    </v-card-text>
    <i-total-calendar
      :mode="calendarMode"
      :no-border="false"
      :date-click="(e)=>onDayClick(e,'week')"
      :highlight="highlight"
      @titleClick="handleTitleClick"
      @next="onDayClick"
      @prev="onDayClick"
    >
      <template v-slot:day="{weekObj}">
        <div v-if="!weekObj.outside">
          <div class="ml-3 day-body">
            <span>Attendance: {{ getDateCount(weekObj.date) }}</span>
          </div>
          <div class="ml-3 day-body">
            <span>Abnormal: {{ getDateCount(weekObj.date,'abnormal') }}</span>
          </div>
          <!-- {{ weekObj.date }} -->
        </div>
      </template>
    </i-total-calendar>
    <div v-if="calendarMode == 'week'">
      <v-card>
        <swipe-list
          v-if="centerAttendanceList.length>0"
          ref="swipeListRef"
          class="scroll-list"
          :style="{ maxHeight: nodeHeight }"
          :items="centerAttendanceList"
        >
          <template v-slot="{ item, index, revealLeft, revealRight, close }">
            <coach-attendance-item
              :item="item"
              :index="index"
              @click="handleRowClick(item,index)"
            ></coach-attendance-item>
          </template>
          <template v-slot:right="{ item }">
            <div
              class="swipeout-action red"
              @click="handleDelete(item)"
            >
              <v-icon
                large
                color="white"
              >
                mdi-trash-can-outline
              </v-icon>
            </div>
          </template>
        </swipe-list>
        <v-card
          v-if="centerAttendanceList.length==0"
          class="card-content"
        >
          <v-list-item>
            <v-list-item-content>
              list is empty ( filtered or just empty )
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-card>
    </div>
    <UpdateAttendanceDialog
      v-model="updateDialog"
      :record="currentRecord"
      @close="handleCloseDialog"
    ></UpdateAttendanceDialog>
    <v-dialog
      v-model="deleteConfirmDialog"
      width="500"
    >
      <v-card>
        <v-card-title>
          <b>Are you sure to delete the attendance?</b>
        </v-card-title>
        <v-card-text>
          <div>
            <div>
              <b>Coach:</b>
              {{ currentRecord.userRecord.fullName }}
            </div>
            <div>
              <b>Attendance Date:</b>
              {{ formatDate(currentRecord.attendanceDate) }}
            </div>
            <div>
              <b>Checkin Time:</b>
              {{ formatTime(currentRecord.checkinDateTime) }}
            </div>
            <div>
              <b>Checkout Time:</b>
              {{ formatTime(currentRecord.checkoutDateTime) }}
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="dark"
            text
            @click="handleCloseDialog"
          >
            Back
          </v-btn>
          <v-btn
            color="dark"
            text
            @click="deleteAttendance"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <CreateAttendanceDialog
      v-model="createDialog"
      :attendance-date="attendanceDate"
      :center-id="centerId"
      :center-desc="centerDesc"
      @close="handleCloseDialog"
    ></CreateAttendanceDialog>
    <v-btn
      v-if="calendarMode === 'week'"
      fab
      class="create-booking-btn"
      elevation="1"
      dark
      fixed
      color="#008800"
      @click="handleCreate"
    >
      <v-icon
        size="36"
        color="white"
      >
        mdi-plus
      </v-icon>
    </v-btn>
  </v-card>
</template>
<script setup>
import { ref, onMounted, computed, toRefs, watch, onBeforeUnmount, nextTick } from 'vue'
import { getVuetify } from '@core/utils'
import ITotalCalendar from '@/components/Calendar/ITotalCalendar'
import { formatTime, formatDate, hasRole, loading } from '@/utils/helper'
import { fetchList, deleteItem, getAttendanceCount } from '@/api/coachAttendance'
import UniversalInput from '@/components/CRUD/UniversalInput.vue'
import '@/styles/swipelist.css'
import SwipeList from '@/components/SwipeList/SwipeList'
import coachAttendanceItem from '@/views/pages/components/AttendanceManagement/CoachAttendanceItem.vue'
import UpdateAttendanceDialog from '@/views/pages/components/AttendanceManagement/UpdateAttendanceDialog.vue'
import CreateAttendanceDialog from '@/views/pages/components/AttendanceManagement/CreateAttendanceDialog.vue'
import { listCoachCenter } from '@/api/bookedCourse'

const createDialog = ref(false)

const deleteConfirmDialog = ref(false)

const coachAttendanceCount = ref([])

const updateDialog = ref(false)
const defaultRecordPlacement = {
  id: -1,
  userRecordID: -1, // 30040,
  centerID: -1,
  center: {
    description: '',
  },
  attendanceDate: '0001-01-01T00:00:00.000Z',
  checkinDateTime: '0001-01-01T00:00:00.0007Z',
  checkoutDateTime: '0001-01-01T00:00:00.0007Z',
  calculated: false,
  userRecord: {
    id: 30040,
    firstName: 'First Name', // Jason
    lastName: 'Last Name', // LI
    username: 'A230300001',
    userNo: 'A230300001',
    mobileNo: '12345678',
    fullName: 'First Name Last Name',
    avatar: 'User/Avatar/30040',
  },
}
const createRecord = ref({ ...defaultRecordPlacement })
const currentRecord = ref({ ...defaultRecordPlacement })

const swipeListRef = ref(null)

const highlight = ref([])
const defaultCalendarMode = 'month'
const selectedDay = ref('')
const calendarMode = ref(defaultCalendarMode)
const coachCenterList = ref([])

const centerAttendanceList = ref([])
function handleTitleClick() {
  console.log('handleTitleClick', calendarMode.value)
  calendarMode.value = defaultCalendarMode
}
const centerId = ref(-1)
const centerIdConfig = ref({
  name: 'centerId',
  label: 'Center',
  type: {
    name: 'select',
    items: coachCenterList.value,
  },
})

const attendanceDate = ref('')
const centerDesc = ref('')
function handleCreate() {
  createDialog.value = true
  nextTick(() => {
    attendanceDate.value = selectedDay.value
    console.log('attendanceDate.value', attendanceDate.value)
    const selectedCenter = coachCenterList.value.find(record => record.id === centerId.value)
    if (selectedCenter) {
      centerDesc.value = selectedCenter.label
    }
  })
  console.log('createRecord.value', createRecord.value)
}

const nodeHeight = ref('0px')
const $vuetify = getVuetify()
const isMobile = computed(() => $vuetify.breakpoint.mdAndDown)
function updateNodeHeight() {
  let extraHeight = 0
  extraHeight = 0
  if (isMobile) {
    extraHeight = 125
  }
  const nodeHeightValue = window.innerHeight - 180 - 40 - extraHeight
  console.log('nodeHeightValue', nodeHeightValue)
  nodeHeight.value = `${nodeHeightValue}px`
}
onBeforeUnmount(() => {
  window.removeEventListener('resize', updateNodeHeight)
})

function fetchAttendance() {
  console.log('fetchAttendance')

  return new Promise(resolve => {
    const postData = {
      page: 0,
      limit: 0,
      attendanceDate: selectedDay.value,
      orderBy: 'CheckinDateTime',
    }
    if (centerId.value) {
      postData.centerId = centerId.value
    }
    if (calendarMode.value === 'week') {
      fetchList(postData).then(result => {
        console.log('result')
        if (result.data) {
          console.log('fetchAttendance', result.data.items)
          const { items } = result.data
          centerAttendanceList.value = items
          resolve(items)
        }
      }).finally(() => {
        loading(false)
      })
    } else {
      getAttendanceCount(postData).then(result => {
        console.log('result')
        if (result.data) {
          const { items } = result.data
          coachAttendanceCount.value = items
          console.log('fetchAttendanceCount', coachAttendanceCount.value)
          resolve(items)
        }
      }).finally(() => {
        loading(false)
      })
    }
  })
}

onMounted(() => {
  updateNodeHeight()
  window.addEventListener('resize', updateNodeHeight)

  listCoachCenter().then(res => {
    const { items } = res.data
    for (let index = 0; index < items.length; index += 1) {
      const item = items[index]
      if (item.center) {
        if (centerId.value === -1) {
          centerId.value = item.center.id
        }
        coachCenterList.value.push({
          id: item.center.id,
          label: item.center.description,
        })
      }
    }
    console.log('listCoachCenter', coachCenterList.value)
    fetchAttendance().then(() => {

    })
  })
})

function deleteAttendance() {
  console.log('deleteAttendance', currentRecord.value)
  loading(true)
  if (currentRecord.value.id > 0) {
    deleteItem(currentRecord.value).then(res => {
      console.log('deleteItem', res)
      fetchAttendance().finally(() => {
        deleteConfirmDialog.value = false
        loading(false)
      })
    })
  } else {
    loading(false)
  }
}
function refresh() {
  fetchAttendance()
}

watch(centerId, newValue => {
  refresh()
})

function handleCloseDialog() {
  currentRecord.value = { ...defaultRecordPlacement }

  updateDialog.value = false
  deleteConfirmDialog.value = false

  if (swipeListRef.value) {
    swipeListRef.value.close()
  }

  refresh()
}

function onDayClick(day, mode) {
  loading(true)
  console.log(day)
  selectedDay.value = day.date
  console.log('selectedDay.value', selectedDay.value)

  // courseStartFilter.value = moment(selectedDay.value).startOf('day').add('08:00').format('yyyy-MM-DD HH:mm:ss')

  if (mode) {
    calendarMode.value = 'week'
  }

  // if (calendarMode.value === 'week') {
  //   // loading(true)
  //   fetchAttendance().finally(() => {
  //     loading(false)
  //   })
  // }else{
  //   refresh()
  // }
  refresh()
}

function handleDelete(item) {
  console.log('handleDelete', item)
  currentRecord.value = item
  deleteConfirmDialog.value = true
}

function handleRowClick(item) {
  console.log('handleRowClick', item)
  updateDialog.value = true
  currentRecord.value = item
}

function getDateCount(date, prop = 'count') {
  let result = 0
  coachAttendanceCount.value.forEach(item => {
    if (item.attendanceDate === date) {
      result = item[prop]
    }
  })

  return result
}
</script>
<style scoped>

.horizontal >>> .v-hl-container {
  /* Space between content and scrollbar */
  /* padding-bottom: 16px; */

  /* For firefox only */
  scrollbar-width: thin;
  /* scrollbar-color: orangered black; */
}

.horizontal >>> .v-hl-container::-webkit-scrollbar {
  height: 0px;
  width: 16px;
  background: transparent;
}
.scroll-list{
  overflow-y: scroll;

  scrollbar-width: thin;
}
.scroll-list::-webkit-scrollbar {
  width: 0px;
  background: transparent;
  /* background-color: DeepSkyBlue; */
}
.scroll-list::-webkit-scrollbar-thumb {
  border-radius: 0px;
  background: #b0b0b0;
  border: solid 0px #e6e6e6;
}
.create-booking-btn-mobile{
  bottom: -28px;
  right:50px
}
.create-booking-btn{
  bottom: 30px;
  right:50px
}
.center-filter{
  max-width: 170px;
}
.header-toolbar{
  border: 1px solid;
    border-top-width: 1px;
    border-right-width: 1px;
    border-bottom-width: 1px;
    border-left-width: 1px;
    border-top-style: solid;
    border-right-style: solid;
    border-bottom-style: solid;
    border-left-style: solid;
    border-color: #cbd5e0;
}

.time-span {
  color: white
}
.day-body{
  font-size: 8px;
}
.create-booking-btn-mobile{
  bottom: -28px;
  right:50px
}
</style>
<style>

.swipeout-list-item{
  min-height: 110px;
}
</style>
